import moment from 'moment';
import {
  GuestManagementGuardGuestFilters,
  GuestManagementGuestFilters,
} from './guestsManagementTypes';
import { InviteVisitorFormValues } from '../../components/modals/InviteVisitorModal';
import { GuestsFiltersDto } from '../../API/guest-management/dto/request/guests-filters.dto';
import { GuardGuestsFiltersDto } from '../../API/guests/dto/request/guard-guests-filters.dto';
import { AddNewGuestRequestDto } from '../../API/guests/dto/request/add-new-guest.request.dto';
import { SpecialNeedEnum } from '../../API/guest-management/enum/special-need.enum';
import { GuestPlaceDto } from '../../API/guests/dto/request/guest-place.dto';

export const guestsManagementAddGuestDto = (
  data: InviteVisitorFormValues,
  space: GuestPlaceDto,
  userId: number,
  companyId: number
): AddNewGuestRequestDto => {
  const timeZoneOffset = 1000 * 60 * 60 * 8; //8hrs

  const inviterNameData = data.invitedName || data.invitedNameFreeText;

  return {
    full_name: data.fullName,
    phone: data.phone ? data.phone : undefined,
    email: data.email || undefined,
    arriving_on:
      new Date(data.arrivingOn[0].setHours(0, 0, 0, 0)).getTime() +
      timeZoneOffset,
    allow_parking: data.allowParking,
    license_number:
      data.licenseNumber && data.allowParking
        ? data.licenseNumber.replace(/ /g, '')
        : undefined,
    user_id: userId,
    company_id: companyId,
    message: data.message,
    building_id: data.building,
    parking_number:
      data.parkingNumber && data.allowParking ? data.parkingNumber : undefined,
    parking_floor_number:
      data.parkingFloorNumber && data.allowParking
        ? data.parkingFloorNumber
        : undefined,
    guest_floors: data.guestFloors,
    inviter_name: data.orderForAnother ? inviterNameData : undefined,
    special_need: data.specialNeed || SpecialNeedEnum.NORMAL,
    place: space,
  };
};

export const guardGuestsFiltersDto = (
  filters: GuestManagementGuardGuestFilters,
  count?: number,
  skip?: number
): GuardGuestsFiltersDto => {
  return {
    full_name: filters.fullName,
    license_number: filters.licenseNumber,
    phone: filters.phone,
    company_id: filters.companyId.value ? +filters.companyId.value : undefined,
    building_id: filters.buildingId.value
      ? +filters.buildingId.value
      : undefined,
    date: filters.arrivalDate?.length
      ? moment(filters.arrivalDate[0]).format('MM/DD/YYYY')
      : undefined,
    take: count,
    skip,
  };
};

export const guestsFiltersDto = (
  filters: GuestManagementGuestFilters,
  count?: number,
  skip?: number,
  scope?: number
): GuestsFiltersDto => {
  return {
    full_name: filters.fullName,
    phone: filters.phone,
    license_number: filters.licenseNumber,
    date: filters.arrivalDate?.length
      ? moment(filters.arrivalDate[0]).format('MM/DD/YYYY')
      : undefined,
    take: count,
    skip,
    scope: scope ? scope : undefined,
  };
};
